<template>
  <div>
    Change Password
  </div>
</template>

<script>
export default {};
</script>
